export const noticeSelector = (state) => state.serviceReducer.board.notice;
export const postsSelector = (state) => state.serviceReducer.board.posts;
export const homeSelector = (state) => state.serviceReducer.home;
export const fittingSelector = (state) => state.serviceReducer.fitting;
export const fittingDetailSelector = (state) =>
  state.serviceReducer.fittingDetail;

  export const fittingSearchSelector = (state) =>
  state.serviceReducer.fittingSearch;
